import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription, timer } from 'rxjs';
import { exhaustMap } from 'rxjs/operators';
import { MetaApiService } from '../../../services/meta-api.service';

/**
 * Aviso fijo mientras el terminal MT5 del Gateway local tiene "Algo Trading" desactivado: en ese
 * estado MetaApiService no envía órdenes. No se puede cerrar; desaparece al activarlo en MT5.
 */
@Component({
  selector: 'app-algo-trading-banner',
  templateUrl: './algo-trading-banner.component.html',
  styleUrls: ['./algo-trading-banner.component.scss'],
})
export class AlgoTradingBannerComponent implements OnInit, OnDestroy {
  private static readonly POLL_MS = 5_000;

  algoTradingOff$: Observable<boolean>;
  comprobando = false;
  private sub: Subscription;

  constructor(private metaApiService: MetaApiService) {
    this.algoTradingOff$ = this.metaApiService.algoTradingOff$;
  }

  ngOnInit(): void {
    // Sin Gateway activo comprobarAlgoTrading no llama al gateway
    this.sub = timer(0, AlgoTradingBannerComponent.POLL_MS)
      .pipe(exhaustMap(() => this.metaApiService.comprobarAlgoTrading()))
      .subscribe();
  }

  comprobar(): void {
    this.comprobando = true;
    this.metaApiService.comprobarAlgoTrading().subscribe({
      complete: () => this.comprobando = false
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
